/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper, IconButton, TablePagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatDateOnly } from '../utils/dateTime';

function VisitanteList({ refresh, onEdit, onVisitanteDeleted }) {
  const { user } = useAuth();
  const [visitantes, setVisitantes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchVisitantes = () => {
    api.get(`/visitantes?page=${page}&limit=${rowsPerPage}`)
      .then((response) => {
        setVisitantes(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => {
        console.error('Erro ao buscar visitantes:', error);
      });
  };

  useEffect(() => {
    fetchVisitantes();
  }, [refresh, page, rowsPerPage]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este visitante?')) return;
    try {
      await api.delete(`/visitantes/${id}`);
      console.log('Visitante deletado com sucesso!');
      onVisitanteDeleted();
      fetchVisitantes();
    } catch (error) {
      console.error('Erro ao deletar visitante:', error);
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="visitantes table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              {user?.tipo_usuario === 'admin' && <TableCell>Empresa ID</TableCell>}
              <TableCell>Resid\u00EAncia</TableCell>
              <TableCell>Visitante</TableCell>
              <TableCell>Data Agendamento</TableCell>
              <TableCell>Hora Agendamento</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visitantes.map((visitante) => (
              <TableRow key={visitante.id} hover>
                <TableCell>{visitante.id}</TableCell>
                {user?.tipo_usuario === 'admin' && <TableCell>{visitante.empresa_id}</TableCell>}
                <TableCell>{visitante.imovel_numero ? `Unid. ${visitante.imovel_numero} - ${visitante.imovel_descricao}` : 'N/A'}</TableCell>
                <TableCell>{visitante.pessoa_nome || 'N/A'}</TableCell>
                <TableCell>{formatDateOnly(visitante.data_agendamento, user)}</TableCell>
                <TableCell>{visitante.hora_agendamento || 'N/A'}</TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(visitante)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(visitante.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Linhas por p\u00E1gina:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default VisitanteList;
